import { render, staticRenderFns } from "./SettingsQrOrder.vue?vue&type=template&id=7aa11e27&"
import script from "./SettingsQrOrder.vue?vue&type=script&lang=js&"
export * from "./SettingsQrOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports